import React from 'react';

const Spinner = () => null;

export default Spinner;
